<template>
  <div>
    <Row v-for="(item, index) in orderSms" :key="index" style="marginTop:15px">
      <Col span="6">
        {{item.sendTime}}
      </Col>
      <Col span="8">
        <p><span>状态：</span>{{['','发送中','发送成功','发送失败'][item.sendStatus]}}</p>
        <p><span>手机号：</span>{{item.phone}}</p>
        <p><span>短信内容：</span>{{item.content}}</p>
      </Col>
    </Row>
  </div>
</template>

<script>
export default {
  props: ['orderSms'],
  data() {
    return {}
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/order/order_detail/order-message.vue